import { createContext, PropsWithChildren, useContext } from "react";

interface ProjectManagersRemoveUsersContextValue {
  handleRemove: () => void;
  isSubmitting: boolean;
}

const ProjectManagersRemoveUsersContext =
  createContext<ProjectManagersRemoveUsersContextValue | null>(null);

export const useProjectManagersRemoveUsersContext = () => {
  const context = useContext(ProjectManagersRemoveUsersContext);
  if (!context) {
    throw new Error(
      "useProjectManagersRemoveUsersContext must be used within ProjectManagersRemoveUsersContextProvider",
    );
  }
  return context;
};

interface ProviderProps extends PropsWithChildren {
  handleRemove: () => void;
  isSubmitting: boolean;
}

export const ProjectManagersRemoveUsersContextProvider = ({
  children,
  handleRemove,
  isSubmitting,
}: ProviderProps) => {
  return (
    <ProjectManagersRemoveUsersContext.Provider
      value={{ handleRemove, isSubmitting }}
    >
      {children}
    </ProjectManagersRemoveUsersContext.Provider>
  );
};
